// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  api_url: 'https://gateway-stage.finpass.com.br/api/v2.1',
  api_matching_url: 'https://gateway-stage.finpass.com.br/matching/v4',
  base_url: 'http://localhost:4200',
  api_sector: 'http://localhost:8080/sectors/v1',
  platform_url: 'http://localhost:4200',
  apiCep: "http://zipcode.finpass.com.br/v1",
  monthsRuleBalance: 7,
  firebaseCompanyRegister: "https://us-central1-landing-page-datasets.cloudfunctions.net/addItem",
  saveDatadogLogs: false,
  env: "local"
};
